import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-sm font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:-translate-y-0.5 hover:shadow-lg",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-orange-700 to-orange-900 text-white hover:from-orange-800 hover:to-orange-950 shadow-sm hover:shadow-lg",
        destructive:
          "bg-gradient-to-r from-red-500 to-red-600 text-white hover:from-red-600 hover:to-red-700 shadow-lg",
        outline:
          "border-2 border-orange-600 bg-white hover:bg-orange-50 hover:border-orange-700 text-orange-950 shadow-sm",
        secondary:
          "bg-orange-100 text-orange-800 hover:bg-orange-200 border border-orange-200 hover:border-orange-300",
        ghost: "hover:bg-orange-100/50 hover:text-orange-700 rounded-xl",
        link: "text-orange-600 underline-offset-4 hover:underline hover:text-orange-700",
        success:
          "bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 shadow-lg",
        warning:
          "bg-gradient-to-r from-amber-400 to-orange-500 text-white hover:from-amber-500 hover:to-orange-600 shadow-lg",
        info: "bg-gradient-to-r from-orange-300 to-orange-400 text-white hover:from-orange-400 hover:to-orange-500 shadow-sm",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-lg px-3",
        lg: "h-10 rounded-xl px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
